import { Card, CardHeader, Typography, CardContent } from "@mui/material";

const MetaCard = ({
  label,
  value,
  bgColor,
}: {
  label: string;
  value: number;

  bgColor: string;
}): React.JSX.Element => (
  <Card>
    <CardHeader
      sx={{
        backgroundColor: bgColor,
        color: "primary.contrastText",
        textAlign: "center",
        padding: "5px 0",
      }}
      title={
        <Typography variant="body2" component="p">
          {label}
        </Typography>
      }
    />
    <CardContent
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        variant="h5"
        component="h5"
        sx={{
          fontWeight: "bold",
        }}
      >
        {value}
      </Typography>
    </CardContent>
  </Card>
);

export default MetaCard;
